export enum Culture {
    esAR = 0,
    enUS = 1
}